import { Component } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { EnumTools } from '../../../tools/enum-tools';
import { SolUrlHandler } from '../../../handlers/sol-url-handler';
import { SolErrorPageComponent, SolErrorPageType } from './sol-error-page.component';

class State {
  private constructor(
    public readonly type: SolErrorPageType,
    public readonly callbackUri: string | undefined,
  ) {}

  public static of(): State {
    return new State(SolErrorPageType.UNKNOWN, undefined);
  }

  public withParams(params: Readonly<Record<string, string>>): State {
    const type = EnumTools.fromString(SolErrorPageType, params['type']) || SolErrorPageType.UNKNOWN;
    return new State(type, params['callbackUri']);
  }
}

/**
 * The routed entry point of {@link SolErrorPageComponent}: it owns the URL, the error page owns the
 * rendering. Registered wherever the error page is reached by navigating (`/error`, external and
 * Vue-only routes); the shell renders `sol-error-page` directly and passes its type as an input.
 */
@Component({
  selector: 'sol-error-route-page',
  imports: [SolErrorPageComponent],
  template: `<sol-error-page [type]="type$()" [callbackUri]="callbackUri$()" />`,
})
export class SolErrorRoutePageComponent extends AbstractComponent<State> {
  // Computed
  protected readonly type$ = this.compute(state => state.type);
  protected readonly callbackUri$ = this.compute(state => state.callbackUri);

  // Handlers
  private readonly urlHandler: SolUrlHandler;

  constructor() {
    super(State.of());

    this.urlHandler = new SolUrlHandler({
      queryParams: params => this.update(state => state.withParams(params)),
    });
  }
}
